import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Grid,
  Autocomplete,
  TextField,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import ClearIcon from "@mui/icons-material/Clear";
import ListItemText from "@mui/material/ListItemText";
import {
  displayFolderList,
  displayFolderListError,
  displayFolderListSuccess,
  displayScenarioList,
  displayScenarioListError,
  displayScenarioListSuccess,
  openErrorDialog,
} from "../../../Redux/Actions/InputData";
import { getRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
  DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API,
  DISPLAY_SCENARIO_FILTER_API,
  MEDIUM_DISPLAY_CHART_BASELINE_CO2_API,
  MEDIUM_DISPLAY_CHART_BASELINE_COST_API,
  MEDIUM_DISPLAY_CHART_COST_PER_TON_API,
  MEDIUM_DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API,
  MEDIUM_DISPLAY_CHART_DISTANCE_PER_TON_API,
  MEDIUM_DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API,
  MEDIUM_DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API,
  MEDIUM_DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API,
  MEDIUM_NUTRITION_DISPLAY_CHART_BASELINE_CO2_API,
  MEDIUM_NUTRITION_DISPLAY_CHART_BASELINE_COST_API,
  MEDIUM_NUTRITION_DISPLAY_CHART_COST_PER_TON_API,
  MEDIUM_NUTRITION_DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API,
  MEDIUM_NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_API,
  MEDIUM_NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API,
  MEDIUM_NUTRITION_DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API,
  MEDIUM_NUTRITION_DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API,
} from "../../../Utils/Config";
import CostPerTonByScenarioChart from "./CostPerTonByScenarioChart";
import DistancePerTonChart from "./DistancePerTonChart";
import OverAllCostByScenarioChart from "./OverAllCostByScenarioChart";
import OverAllCo2ByScenarioChart from "./OverAllCo2tByScenarioChart";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import btnDownloadIcon from ".././../../Assests/download.svg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
// import { position } from "html2canvas/dist/types/css/property-descriptors/position";

// import TestStackChart from "./TestStackChart";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
interface Scenario {
  scenario_id: number;
  folder_id: number;
  scenario: string;
}

function CompareCharts(props: any) {
  const [selectFolder, setSelectFolder] = useState<any>("Folder");
  const [selectedInnerFolderId, setSelectedInnerFolderId] = useState<any>(0);
  const [folderOptions, setFolderOptions] = useState<any>([]);
  const [selectScenario1, setSelectScenario1] = useState<any>("Baseline");
  const [selectScenario2, setSelectScenario2] = useState<any>("Scenario ");
  const [selectScenario1Id, setSelectScenario1Id] = useState<any>(0);
  const [selectScenario2Id, setSelectScenario2Id] = useState<any>(0);
  const [selectBaseline, setSelectBaseline] = useState<any>("Baseline");
  const [tabsValue, setTabsValue] = React.useState("1");

  const [scenarioOptions, setScenarioOptions] = useState<any>([]);
  const [secondScenarioOptions, setSecondScenarioOptions] = useState<any>([]);
  const dispatch: any = useDispatch();
  const [overAllCostData, setOverAllCostData] = React.useState([]);
  const [nutritionOverAllCostData, setNutritionOverAllCostData] =
    React.useState([]);
  const [overAllCo2Data, setOverAllCo2Data] = React.useState([]);
  const [nutritionOverAllCo2Data, setNutritionOverAllCo2Data] = React.useState(
    []
  );
  const [costPerTonData, setCostPerTonData] = React.useState([]);
  const [nutritionCostPerTonData, setNutritionCostPerTonData] = React.useState(
    []
  );

  const [timePeriodCostPerTonData, setTimePeriodCostPerTonData] =
    React.useState({ label: [], data: [] });
  const [
    nutritionTimePeriodCostPerTonData,
    setNutritionTimePeriodCostPerTonData,
  ] = React.useState({ label: [], data: [] });
  const [timePeriodOverAllCost, setTimPeriodOverAllCost] = React.useState({
    label: [],
    data: [],
  });
  const [nutritionTimePeriodOverAllCost, setNutritionTimPeriodOverAllCost] =
    React.useState({ label: [], data: [] });
  const [timePeriodOverAllCo2, setTimePeriodOverAllCo2] = React.useState({
    label: [],
    data: [],
  });
  const [nutritionTimePeriodOverAllCo2, setNutritionTimePeriodOverAllCo2] =
    React.useState({ label: [], data: [] });

  const [timePeriodDistanceData, setTimePeriodDistanceData] = React.useState(
    []
  );
  const [nutritionTimePeriodDistanceData, setNutritionTimePeriodDistanceData] =
    React.useState([]);
  const [distanceCostPerTonData, setDistanceCostPerTonData] = React.useState(
    []
  );
  const [nutritionDistanceCostPerTonData, setNutritionDistanceCostPerTonData] =
    React.useState([]);

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  const selectedUploadScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedUploadScenarioId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData
  );

  const loadInitialData = () => {
    if (selectedFolderId > 0 && folderOptions.length > 0) {
      setSelectedInnerFolderId(selectedFolderId);
      const folderItem = folderOptions.find((obj: any) => {
        return obj.id === selectedFolderId;
      });
      if (folderItem != null) {
        setSelectFolder(folderItem?.folder);
        callScenarioFilterApi(folderItem?.id);
        setSelectScenario1("Baseline");
        setSelectScenario2("Scenario");
        loadCharts(selectedFolderId, 0, -1);
      }
    }
  };

  useEffect(() => {
    callFolderFilterApi();
    setSelectedSce([]);
  }, [selectedFolderId]);

  useEffect(() => {
    if (selectedScenarioId > 0) setScenarioValues(selectedScenarioId);
    loadCharts(selectedFolderId, selectScenario1Id, selectedScenarioId);
  }, [selectedScenarioId]);

  const setScenarioValues = (scenarioId: any) => {
    const folderNewItem = secondScenarioOptions?.find((obj: any) => {
      return obj.scenario_id === scenarioId;
    });
    setSelectScenario2(folderNewItem?.scenario);
  };
  const setIitialValues = () => {
    setOverAllCostData([]);
    setNutritionOverAllCostData([]);
    setOverAllCo2Data([]);
    setNutritionOverAllCo2Data([]);
    setCostPerTonData([]);
    setNutritionCostPerTonData([]);
    setTimePeriodCostPerTonData({ label: [], data: [] });
    setNutritionTimePeriodCostPerTonData({ label: [], data: [] });
    setTimPeriodOverAllCost({ label: [], data: [] });
    setNutritionTimPeriodOverAllCost({ label: [], data: [] });
    setTimePeriodOverAllCo2({ label: [], data: [] });
    setNutritionTimePeriodOverAllCo2({ label: [], data: [] });
    setSelectFolder("Folder");
    setScenarioOptions([]);
    setScenarioOptions([]);
    setSecondScenarioOptions([]);
    setSelectScenario1("Baseline");
    setSelectScenario2("Scenario");
  };
  useEffect(() => {
    callFolderFilterApi();
    setIitialValues();
  }, [selectedUsecaseId, selectedCategoryId]);

  useEffect(() => {
    setIitialValues();
    loadInitialData();
  }, [folderOptions]);

  const callFolderFilterApi = () => {
    dispatch(displayFolderList());
    const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        useCase: selectedUsecaseId,
        category: selectedCategoryId,
        createdBy: userData.userId,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setFolderOptions(response.data.data);
          dispatch(displayFolderListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayFolderListError(error.message));
      });
  };

  const handleDownload = (e: any) => {
    let elem: any = document.getElementById("chartcontainer");
    html2canvas(elem).then(function (canvas) {
      var wid: number;
      var hgt: number;
      var img = canvas.toDataURL("image/png", (wid = canvas.width));
      var doc = new jsPDF("p", "pt", "a4");
      var width = 550; // doc.internal.pageSize.width;
      var height = 600; // width * hratio
      doc.addImage(img, "JPEG", 10, 10, width, height);
      doc.save("Compare_Charts.pdf");
    });
  };

  /**Redux state */

  const overallCostByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls = API_BASE_URL + MEDIUM_DISPLAY_CHART_BASELINE_COST_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId:
          scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response: any) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setOverAllCostData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const overallCo2ByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls = API_BASE_URL + MEDIUM_DISPLAY_CHART_BASELINE_CO2_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId:
          scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response: any) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setOverAllCo2Data(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const costPerTonByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls = API_BASE_URL + MEDIUM_DISPLAY_CHART_COST_PER_TON_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId:
          scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setCostPerTonData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const distanceCostPerTonByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls = API_BASE_URL + MEDIUM_DISPLAY_CHART_DISTANCE_PER_TON_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId:
          scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setDistanceCostPerTonData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const distanceCostByScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + MEDIUM_DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setTimePeriodDistanceData(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const CostPerTonByScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + MEDIUM_DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setTimePeriodCostPerTonData(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const CostPOverAllCostPerScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + MEDIUM_DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setTimPeriodOverAllCost(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const OverAllCo2PerScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + MEDIUM_DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setTimePeriodOverAllCo2(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const mediumnutritionOverallCostByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_CHART_BASELINE_COST_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId:
          scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response: any) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setNutritionOverAllCostData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const mediumnutritionOverallCo2ByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls = API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_CHART_BASELINE_CO2_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId:
          scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response: any) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setNutritionOverAllCo2Data(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const mediumnutritionCostPerTonByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls = API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_CHART_COST_PER_TON_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId:
          scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setNutritionCostPerTonData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const mediumnutritionDistanceCostPerTonByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId:
          scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setNutritionDistanceCostPerTonData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const mediumnutritionDistanceCostByScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL +
      MEDIUM_NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setNutritionTimePeriodDistanceData(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const mediumNutritionCostPerTonByScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL +
      MEDIUM_NUTRITION_DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setNutritionTimePeriodCostPerTonData(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const mediumNutritionCostPOverAllCostPerScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL +
      MEDIUM_NUTRITION_DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setNutritionTimPeriodOverAllCost(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const mediumNutritionOverAllCo2PerScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL +
      MEDIUM_NUTRITION_DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setNutritionTimePeriodOverAllCo2(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const [selectedSce, setSelectedSce] = useState<Scenario[]>([]);

  const handleChange = (event: any) => {
    const selectedValues = event.target.value as Scenario[];
    setSelectedSce(selectedValues);
    loadCharts(selectedInnerFolderId, selectedValues, selectScenario2Id);
  };

  const handleClear = () => {
    loadCharts(selectedInnerFolderId, [], selectScenario2Id);
    setSelectedSce([]);
  };

  const [selectedScenarios, setSelectedScenarios] = useState<any>([]);
  const handleChangeSelectScenario1 = (event: any, newValue: any) => {
    setSelectedScenarios(newValue);
    let resultScenarioId = 0;

    loadCharts(selectedInnerFolderId, newValue, selectScenario2Id);
  };

  const loadScenarios = (scenario_id: any) => {
    const filtereddata = scenarioOptions.filter((scenario: any) => {
      if (scenario.scenario_id !== scenario_id) return scenario;
    });

    setSecondScenarioOptions(filtereddata);
  };

  if (props.filterArray !== 0) {
  }

  const handleChangeSelectFolder = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectFolder(value.folder);
    setSelectedInnerFolderId(value.id);
    callScenarioFilterApi(value.id);
    loadCharts(selectedInnerFolderId, selectScenario1Id, 0);
  };

  const callScenarioFilterApi = (id: any) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + DISPLAY_SCENARIO_FILTER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, { folder_id: id, createdBy: userData.userId }, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          let responseArray = [];
          responseArray.push(response.data);
          setScenarioOptions(response.data);
          setSecondScenarioOptions(response.data);
          dispatch(displayScenarioListSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const handleChangeSelectScenario2 = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectScenario2(value.scenario);
    setSelectScenario2Id(value.scenario_id);
    loadCharts(selectedInnerFolderId, selectScenario1Id, value.scenario_id);
  };

  const loadCharts = (
    folderId: number,
    selectedScenarios: any,
    scenario2Id: number
  ) => {
    const selectedScenarioIds: any = [];
    selectedScenarios.length > 0 &&
      selectedScenarios.map((scenario: any) =>
        selectedScenarioIds.push(scenario.scenario_id)
      );
    if (selectedUsecaseId === 2 && selectedCategoryId === 1) {
      overallCostByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      costPerTonByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      distanceCostPerTonByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );

      overallCo2ByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
    } else {
      mediumnutritionOverallCostByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      mediumnutritionCostPerTonByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      mediumnutritionDistanceCostPerTonByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      //TimePeriod
      // mediumNutritionCostPerTonByScenarioForTimePeriodApi(folderId,selectedScenarios,scenario2Id);
      // mediumNutritionCostPOverAllCostPerScenarioForTimePeriodApi(folderId,selectedScenarios,scenario2Id);
      // mediumnutritionDistanceCostByScenarioForTimePeriodApi(folderId,selectedScenarios,scenario2Id);
      //Co2
      mediumnutritionOverallCo2ByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      // mediumNutritionOverAllCo2PerScenarioForTimePeriodApi(folderId,selectedScenarios,scenario2Id);
    }
  };

  return (
    <>
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Compare scenarios</h3>
          </div>
          <div className="filters">
            <div className="filter-item" style={{ backgroundColor: "white" }}>
              <FormControl fullWidth className="selectDropdown1">
                <Select
                  id="simple-select-1"
                  value={selectFolder}
                  placeholder="Select Folder"
                  onChange={handleChangeSelectFolder}
                  renderValue={(selected: any) => selected}
                  className="select-short-term"
                >
                  {folderOptions.map((d: any) => {
                    return (
                      <MenuItem key={d.id} value={d}>
                        {/* {d.folder + " (" + d.time_period + ")"} */}
                        {d.folder}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <FormControl sx={{ width: 300 }}>
              <InputLabel id="demo-multiple-checkbox-label">
                Select Scenarios
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedSce}
                onChange={handleChange}
                input={
                  <OutlinedInput
                    label="Select Scenarios"
                    endAdornment={
                      selectedSce.length > 0 && (
                        <ClearIcon
                          style={{ cursor: "pointer" }}
                          onClick={handleClear}
                        />
                      )
                    }
                  />
                }
                renderValue={(selected) =>
                  selected.map((item: any) => item.scenario).join(", ")
                }
              >
                {scenarioOptions.map((scenario: any) => (
                  <MenuItem key={scenario.scenario_id} value={scenario}>
                    <Checkbox checked={selectedSce.indexOf(scenario) > -1} />
                    <ListItemText primary={scenario.scenario} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className="content-download-btn"
                  data-html2canvas-ignore="true"
                  onClick={handleDownload}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
        {selectedCategoryId !== 2 ? (
          <div className="tabs-area">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabsValue}>
                <TabPanel value="1" className="pb-0">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      Landed Cost/Manufacture CO2/Distance per ton
                    </p>
                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Conversion Cost/Transportation CO2
                    </p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Pri Transportation Cost
                    </p>
                  </div>
                  <div id="chartcontainer" className="chart-area">
                    {/* <Tabs1Charts filterArray={distanceCostPerTonData}/> */}
                  </div>
                </TabPanel>
                <TabPanel value="2">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>Fixed
                      Cost2
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Production Cost
                    </p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Procurement Cost
                    </p>
                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Production Cost
                    </p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      Procurement Cost
                    </p>
                  </div>
                </TabPanel>
                <TabPanel value="3" className="legendarea">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>Fixed
                      Cost3
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Production Cost
                    </p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Procurement Cost
                    </p>
                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Production Cost
                    </p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      Procurement Cost
                    </p>
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        ) : (
          <div className="tabs-area">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabsValue}>
                <TabPanel value="1" className="pb-0">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>RM/PM
                      landed cost
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Processing cost/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>SFG
                      transportation cost/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Packaging cost/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      Primary Transportation cost/Distance/CO2
                    </p>
                  </div>
                  <div id="chartcontainer" className="chart-area">
                    {/* <Tabs1Charts filterArray={distanceCostPerTonData}/> */}
                  </div>
                </TabPanel>
                <TabPanel value="2">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>RM/PM
                      landed cost
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Processing cost
                    </p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>SFG
                      transportation cost
                    </p>
                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Packaging cost
                    </p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      Primary Transportation cost
                    </p>
                  </div>
                </TabPanel>
                <TabPanel value="3" className="legendarea">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>RM/PM
                      landed cost
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Processing cost
                    </p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>SFG
                      transportation cost
                    </p>
                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Packaging cost
                    </p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      Primary Transportation cost
                    </p>
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        )}
      </div>

      <div>
        <div className="costPerTonChart">
          <OverAllCostByScenarioChart
            timPeriodOverAllCost={
              selectedCategoryId === 1
                ? timePeriodOverAllCost
                : nutritionTimePeriodOverAllCost
            }
            overAllCostData={
              selectedCategoryId === 1
                ? overAllCostData
                : nutritionOverAllCostData
            }
          />
        </div>
        <div className="costPerTonChart">
          <CostPerTonByScenarioChart
            timePeriodCostPerTonData={
              selectedCategoryId === 1
                ? timePeriodCostPerTonData
                : nutritionTimePeriodCostPerTonData
            }
            costPerTonData={
              selectedCategoryId === 1
                ? costPerTonData
                : nutritionCostPerTonData
            }
          />
        </div>
        <div className="costPerTonChart">
          <DistancePerTonChart
            timePeriodDistanceData={
              selectedCategoryId === 1
                ? timePeriodDistanceData
                : nutritionTimePeriodDistanceData
            }
            distnaceCostPerTonData={
              selectedCategoryId === 1
                ? distanceCostPerTonData
                : nutritionDistanceCostPerTonData
            }
          />
        </div>
        <div className="costPerTonChart">
          <OverAllCo2ByScenarioChart
            timePeriodOverAllCo2={
              selectedCategoryId === 1
                ? timePeriodOverAllCo2
                : nutritionTimePeriodOverAllCo2
            }
            overAllCo2Data={
              selectedCategoryId === 1
                ? overAllCo2Data
                : nutritionOverAllCo2Data
            }
          />
        </div>
      </div>
    </>
  );
}
export default CompareCharts;
